import React from "react";
import PropTypes from "prop-types";
import { LocaleProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_US";
import zhCN from "antd/lib/locale-provider/zh_CN";

import {
    LANGUAGE_STORAGE_KEY,
    LanguageContext,
    getInitialLanguage,
    translate,
    translateDom,
} from "./index";

class LanguageProvider extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    state = { language: getInitialLanguage() };

    componentDidMount() {
        this.applyLanguage();
        this.observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node =>
                    translateDom(node, this.state.language)
                );
            });
        });
        this.observer.observe(document.getElementById("root"), {
            childList: true,
            subtree: true,
        });
    }

    componentDidUpdate(_, previousState) {
        if (previousState.language !== this.state.language) this.applyLanguage();
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    setLanguage = language => {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        this.setState({ language });
    };

    applyLanguage = () => {
        const { language } = this.state;
        document.documentElement.lang = language;
        translateDom(document.getElementById("root"), language);
    };

    render() {
        const { language } = this.state;
        const value = {
            language,
            setLanguage: this.setLanguage,
            t: text => translate(text, language),
        };
        return (
            <LanguageContext.Provider value={value}>
                <LocaleProvider locale={language === "zh-CN" ? zhCN : enUS}>
                    {this.props.children}
                </LocaleProvider>
            </LanguageContext.Provider>
        );
    }
}

export default LanguageProvider;
